import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import dialog from 'simple-dialog';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/users/wechat-qrcode-sign-up.scss';

Component('tr-wechat-qrcode-sign-up', {
  mixins: [eventListenerMixin],

  properties: {
    qrcodeUrl: String,
    formUrl: String,

    signed: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.loadQrcode();
  },

  ready() {
    this.mobileVerification = this.querySelector('tr-mobile-verification');
    this.listenTo(this.mobileVerification, {
      'tao:verified': (event) => {
        this.showSignUpForm(event.detail.mobile);
      },
      'tao:smsCodeSended': (event) => {
        this.querySelector(
          '.mobile-verification-box .bd-title .desc',
        ).classList.toggle('hide', event.detail);
      },
    });
  },

  disconnected() {
    this.stopListening();
  },

  loadQrcode() {
    $.ajax({
      url: this.qrcodeUrl,
      type: 'get',
      dataType: 'json',
      success: (result) => {
        if (result.success) {
          this.showQrcode(result.qrcode_url);
          this.subscribeChannel(result.channel);
        } else {
          dialog.message({ content: result.message });
        }
      },
    });
  },

  showQrcode(qrcodeUrl) {
    const qrcodeWrapper = this.querySelector('.qrcode-wrapper');
    qrcodeWrapper.classList.remove('loading');
    qrcodeWrapper.querySelector('.qrcode').src = qrcodeUrl;
  },

  subscribeChannel(channelName) {
    const channel = window.tower.tempPusher(channelName);
    channel.bind('WECHAT_SIGN_UP', (result) => {
      if (!result.success) {
        this.qrcodeTrack(channelName, 'failed');
        return;
      }

      this.qrcodeTrack(channelName, 'callbacked');
      this.snsBindGuid = result.snsBindGuid;
      if (result.mobileVerificationRequired) {
        this.signed = true;
        this.mobileVerification.focusMobileInput();
      } else {
        this.showSignUpForm();
      }
    });
  },

  qrcodeTrack(channelName, stateName) {
    $.ajax({
      url: '/wechat/qrcode',
      method: 'PUT',
      dataType: 'json',
      data: {
        channel: channelName,
        state: stateName,
      },
    });
  },

  showSignUpForm(mobile) {
    $.ajax({
      url: `${this.formUrl}?${$.param({
        sns_bind_guid: this.snsBindGuid,
        mobile,
      })}`,
      method: 'GET',
      dataType: 'script',
    });
  },
});
